var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugHouseholdFSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11,12.5c-1.9296875,0-3.5,1.5703125-3.5,3.5s1.5703125,3.5,3.5,3.5s3.5-1.5703125,3.5-3.5S12.9296875,12.5,11,12.5z  M11,17.5c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5s1.5,0.6728516,1.5,1.5S11.8271484,17.5,11,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,12.5c-1.9296875,0-3.5,1.5703125-3.5,3.5s1.5703125,3.5,3.5,3.5s3.5-1.5703125,3.5-3.5S22.9296875,12.5,21,12.5z  M21,17.5c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5s1.5,0.6728516,1.5,1.5S21.8271484,17.5,21,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,11h-2V8c0-3.859375-3.140625-7-7-7h-1c-1.1025391,0-2,0.8974609-2,2v2h-2V3c0-1.1025391-0.8974609-2-2-2h-1 C8.140625,1,5,4.140625,5,8v3H3c-1.1025391,0-2,0.8974609-2,2v6c0,1.1025391,0.8974609,2,2,2h2v3c0,3.859375,3.140625,7,7,7h1 c1.1025391,0,2-0.8974609,2-2v-2h2v2c0,1.1025391,0.8974609,2,2,2h1c3.859375,0,7-3.140625,7-7v-3h2c1.1025391,0,2-0.8974609,2-2 v-6C31,11.8974609,30.1025391,11,29,11z M29,19h-2c-1.1025391,0-2,0.8974609-2,2v3c0,2.7568359-2.2431641,5-5,5h-1v-2 c0-1.1025391-0.8974609-2-2-2h-2c-1.1025391,0-2,0.8974609-2,2v2h-1c-2.7568359,0-5-2.2431641-5-5v-3c0-1.1025391-0.8974609-2-2-2 H3v-6h2c1.1025391,0,2-0.8974609,2-2V8c0-2.7568359,2.2431641-5,5-5h1v2c0,1.1025391,0.8974609,2,2,2h2 c1.1025391,0,2-0.8974609,2-2V3h1c2.7568359,0,5,2.2431641,5,5v3c0,1.1025391,0.8974609,2,2,2h2V19z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugHouseholdFSmall);
export default __webpack_public_path__ + "static/media/plug-household-f--small.0b5cf57d2d157abc00f1ce9316ad70fc.svg";
export { ForwardRef as ReactComponent };